import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/nurseryApi";
import { Leaf, ArrowRight, Calendar } from "@phosphor-icons/react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  const [hero, ...rest] = posts;

  return (
    <div className="organic-bg" style={{ minHeight: "100vh" }}>
      <header style={{ background: "rgba(250, 247, 239, 0.85)", backdropFilter: "saturate(160%) blur(10px)", position: "sticky", top: 0, zIndex: 30, borderBottom: "1px solid var(--border)" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }} data-testid="blog-brand">
            <div style={{ width: 38, height: 38, background: "var(--primary)", borderRadius: 12, display: "grid", placeItems: "center" }}>
              <Leaf size={20} color="white" weight="fill" />
            </div>
            <div>
              <div className="font-display" style={{ fontSize: 20, lineHeight: 1 }}>NurserySense</div>
              <div style={{ fontSize: 11, color: "var(--muted-fg)", marginTop: 2 }}>Field Notes</div>
            </div>
          </Link>
          <div style={{ display: "flex", gap: 8 }}>
            <Link to="/login" className="btn btn-ghost" data-testid="blog-login-btn">Sign in</Link>
            <Link to="/apply" className="btn btn-primary" data-testid="blog-cta-register">Apply for founding slot <ArrowRight size={14} weight="bold" /></Link>
          </div>
        </div>
      </header>

      <section style={{ padding: "64px 0 32px", textAlign: "center" }}>
        <div style={{ maxWidth: 760, margin: "0 auto", padding: "0 24px" }}>
          <span className="badge badge-soft">Field Notes · NurserySense Journal</span>
          <h1 className="font-display" style={{ fontSize: "clamp(44px, 7vw, 80px)", marginTop: 18, lineHeight: 1, letterSpacing: "-0.02em" }}>
            Stories from the rows.
          </h1>
          <p style={{ fontSize: 18, color: "var(--text-soft)", marginTop: 18, lineHeight: 1.55 }}>
            Tips, demand forecasts, and lessons from the Nursery Capital of the World — written for the people who actually walk the fields.
          </p>
        </div>
      </section>

      <section style={{ padding: "32px 0 96px" }}>
        <div style={{ maxWidth: 1240, margin: "0 auto", padding: "0 24px" }}>
          {hero && (
            <Link to={`/blog/${hero.slug}`} className="card card-hover" style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", overflow: "hidden", textDecoration: "none", color: "inherit", marginBottom: 36 }} data-testid={`blog-hero-${hero.slug}`}>
              <div style={{ minHeight: 360, background: "var(--bg-alt)", overflow: "hidden" }}>
                {hero.cover_image && <img src={hero.cover_image} alt={hero.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />}
              </div>
              <div style={{ padding: 36, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <span className="badge badge-soft" style={{ alignSelf: "flex-start" }}>{hero.tag}</span>
                <h2 className="font-display" style={{ fontSize: 36, marginTop: 14, lineHeight: 1.1 }}>{hero.title}</h2>
                <p style={{ fontSize: 16, color: "var(--text-soft)", marginTop: 12, lineHeight: 1.55 }}>{hero.excerpt}</p>
                <div style={{ marginTop: 18, display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: "var(--muted-fg)" }}>
                  <Calendar size={13} weight="bold" /> {new Date(hero.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                  <span>·</span>
                  <span>{hero.author}</span>
                </div>
                <div style={{ marginTop: 16, color: "var(--secondary)", fontWeight: 700, fontSize: 14 }}>Read article →</div>
              </div>
            </Link>
          )}

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 20 }}>
            {rest.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="card card-hover" style={{ padding: 0, overflow: "hidden", textDecoration: "none", color: "inherit" }} data-testid={`blog-card-${p.slug}`}>
                {p.cover_image && (
                  <div style={{ height: 200, background: "var(--bg-alt)", overflow: "hidden" }}>
                    <img src={p.cover_image} alt={p.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                  </div>
                )}
                <div style={{ padding: 22 }}>
                  <span className="badge badge-soft">{p.tag}</span>
                  <h3 className="font-display" style={{ fontSize: 22, marginTop: 12, lineHeight: 1.15 }}>{p.title}</h3>
                  <p style={{ fontSize: 14, color: "var(--text-soft)", marginTop: 10, lineHeight: 1.55 }}>{p.excerpt}</p>
                  <div style={{ marginTop: 14, fontSize: 12, color: "var(--muted-fg)" }}>
                    {new Date(p.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })} · {p.author}
                  </div>
                </div>
              </Link>
            ))}
            {posts.length === 0 && (
              <div className="card" style={{ padding: 40, textAlign: "center", color: "var(--muted-fg)", gridColumn: "1 / -1" }}>No posts yet. Check back soon.</div>
            )}
          </div>
        </div>
      </section>

      <footer style={{ background: "var(--text)", color: "rgba(255,255,255,0.7)", padding: "32px 24px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 14, fontSize: 13 }}>
          <div>© 2026 NurserySense · McMinnville, TN</div>
          <Link to="/" style={{ color: "var(--accent)", textDecoration: "underline" }}>Back to home</Link>
        </div>
      </footer>
    </div>
  );
}
